// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"f6260f46","79":"1a6ef107","185":"44f5bd36","285":"4970d98b","667":"38fa16e4","974":"75e01a3f"}[chunkId] + ".css";
};